"use client";

import { motion } from "motion/react";
import CommonSchema from "@/components/common/CommonSchema";
import {
  Heart,
  Users,
  Check,
  Calendar,
  Mail,
  ArrowRight,
  Star,
  Sparkles,
  Phone,
  MapPin,
} from "lucide-react";
import Image from "next/image";
import { FadeInSection } from "@/components/common/FadeInSection";
import {
  cleanHeaderTags,
  createLookupObject,
  isValidImgSrc,
} from "@/_helper/helper";
import { useAppSelector } from "@/store/hooks";
import { ISettings } from "@/slices/homeSlice";
import Link from "next/link";
import { useEffect, useState, useRef } from "react";
// import dynamic from "next/dynamic";
// const Slider = dynamic(() => import("react-slick"), { ssr: false });
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Banner } from "../common/Banner";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function EventDetailClient({
  eventDetail,
  cmsData,
}: {
  eventDetail: any;
  cmsData: any;
}) {
  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, any>>({});
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentGallery, setCurrentGallery] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (images: string[], index: number) => {
    setCurrentGallery(images.map((src) => ({ src })));
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  useEffect(() => {
    if (cmsData && cmsData.length > 0) {
      setLookUpCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  // Slider State
  const [mounted, setMounted] = useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    // Autoplay logic
    const autoplay = setInterval(() => {
      emblaApi.scrollNext();
    }, 5000);

    emblaApi.on("select", () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    });

    return () => clearInterval(autoplay);
  }, [emblaApi]);

  const totalTestimonials = eventDetail?.EventTestimonial?.length || 0;

  const SettingList = useAppSelector((state) => state.home.SettingList);
  const Settings: Record<string, ISettings> = SettingList?.reduce(
    (acc, item) => {
      acc[item?.SettingKey] = item;
      return acc;
    },
    {} as Record<string, ISettings>,
  );

  const EventPhoneNo = Settings?.["EventPhoneNo"]?.SettingValue;
  const EventPhoneNo2 = Settings?.["EventPhoneNo2"]?.SettingValue;
  const EventEmailID = Settings?.["EventEmailID"]?.SettingValue;
  const EventEmailID2 = Settings?.["EventEmailID2"]?.SettingValue;
  const EventCallTiming = Settings?.["EventCallTiming"]?.SettingValue;

  // const packages = [
  //   {
  //     name: "Silver Package",
  //     price: "₹2,50,000",
  //     guests: "Up to 100 Guests",
  //     features: [
  //       "Basic Venue Decoration",
  //       "Standard Catering (Veg)",
  //       "Basic Sound System",
  //       "20 Guest Rooms",
  //       "Complimentary Planning Session",
  //       "Parking Facilities",
  //     ],
  //   },
  //   {
  //     name: "Gold Package",
  //     price: "₹5,00,000",
  //     guests: "Up to 250 Guests",
  //     popular: true,
  //     features: [
  //       "Premium Venue Decoration",
  //       "Deluxe Catering (Veg + Non-Veg)",
  //       "Professional Sound & Lighting",
  //       "40 Guest Rooms",
  //       "Dedicated Wedding Planner",
  //       "Photography Package (6 hours)",
  //       "Welcome Drinks",
  //       "Parking & Valet Service",
  //     ],
  //   },
  //   {
  //     name: "Platinum Package",
  //     price: "₹10,00,000",
  //     guests: "Up to 500 Guests",
  //     features: [
  //       "Royal Themed Decoration",
  //       "Premium Multi-Cuisine Catering",
  //       "Complete AV & Stage Setup",
  //       "60 Guest Rooms + Suite",
  //       "Full Wedding Planning Team",
  //       "Photography + Videography (Full Day)",
  //       "Mehendi & Sangeet Arrangements",
  //       "Live Entertainment",
  //       "Bridal Suite Complimentary",
  //       "Airport Transfers",
  //       "Premium Bar Service",
  //     ],
  //   },
  // ];

  const gallery = [
    ...(eventDetail?.EventInnerimage?.map((img: any) => img?.ImageGallery) ||
      []),
  ].filter(Boolean);

  return (
    <div className="min-h-screen bg-[#fdfcfa]">
      <CommonSchema />
      {/* Hero */}
      {/* <section className="relative h-[80vh] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70 z-10" />
        <Image
          src={
            isValidImgSrc(eventDetail.BannerImage || eventDetail.MainImage)
              ? eventDetail.BannerImage || eventDetail.MainImage
              : "/imports/placeholder.png"
          }
          alt={eventDetail.Title}
          fill
          className="object-cover"
          priority
        />

        <div className="absolute inset-0 z-20 flex items-center justify-center text-center px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl"
          >
            <Heart
              className="w-16 h-16 text-[#d4af37] mx-auto mb-6"
              fill="#d4af37"
            />
            <h1
              className="text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                fontWeight: 400,
              }}
            >
              {eventDetail?.Title?.split(" ")[0]}{" "}
              <span style={{ fontWeight: 600, fontStyle: "italic" }}>
                {eventDetail?.Title?.split(" ")?.slice(1)?.join(" ") || ""}
              </span>
            </h1>
            <div
              className="text-xl md:text-2xl text-white/90 mb-8"
              style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
              dangerouslySetInnerHTML={{
                __html: eventDetail.ShortDescription,
              }}
            />

            <div
              className="flex flex-wrap items-center justify-center gap-6 text-white/90"
              style={{ fontFamily: "Jost, sans-serif" }}
            >
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5" />
                <span>{eventDetail.Capacity}</span>
              </div>
              <div className="w-1 h-1 bg-white/50 rounded-full" />
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                <span>5 Unique Venues</span>
              </div>
              <div className="w-1 h-1 bg-white/50 rounded-full" />
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5" fill="#d4af37" stroke="#d4af37" />
                <span>5-Star Service</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section> */}

      <Banner
        title={eventDetail?.Title || "Event Detail"}
        description={eventDetail?.ShortDescription}
        bgImage={eventDetail?.BannerImage || eventDetail?.MainImage}
        // icon={<Heart className="w-12 h-12 text-[#d4af37]" fill="#d4af37" />}
        backLinkText="Back to Events"
        backLinkUrl="/events"
      />

      {/* Overview */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <FadeInSection>
              <div className="space-y-6">
                <p
                  className="text-[#c9a961] tracking-widest uppercase"
                  style={{
                    fontFamily: "Jost, sans-serif",
                    fontSize: "0.875rem",
                  }}
                >
                  {eventDetail.Tagline}
                </p>
                <h2
                  className="text-4xl md:text-5xl text-[#2a2520] leading-tight"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontWeight: 400,
                  }}
                >
                  An Event Like{" "}
                  <span style={{ fontWeight: 600 }}>No Other</span>
                </h2>
                <div
                  className="text-[#2a2520]/70 text-lg leading-relaxed blog-content"
                  style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
                  dangerouslySetInnerHTML={{
                    __html: cleanHeaderTags(eventDetail.LongDescription),
                  }}
                />

                <div className="grid grid-cols-2 gap-4 pt-6">
                  {[
                    {
                      icon: Heart,
                      label: "Romantic Settings",
                      value: eventDetail.RomanticSettings,
                    },
                    {
                      icon: Users,
                      label: "Guest Capacity",
                      value: eventDetail.GuestCapacity,
                    },
                    {
                      icon: Sparkles,
                      label: "Custom Packages",
                      value: eventDetail.CustomPackages,
                    },
                    {
                      icon: Calendar,
                      label: "Availability",
                      value: "Year Round",
                    },
                  ].map((item, i) => (
                    <div key={i} className="bg-[#f5f1ec] p-6">
                      <item.icon className="w-8 h-8 text-[#5a6f3e] mb-3" />
                      <p
                        className="text-sm text-[#2a2520]/60 mb-1"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        {item.label}
                      </p>
                      <p
                        className="text-lg text-[#2a2520]"
                        style={{
                          fontFamily: "Jost, sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.2}>
              <div className="grid grid-cols-2 gap-4">
                {gallery.slice(0, 4).map((img: string, i: number) => (
                  <motion.div
                    key={i}
                    whileHover={{ scale: 1.05, zIndex: 10 }}
                    className="relative overflow-hidden h-64 shadow-lg group cursor-pointer"
                    onClick={() => openLightbox(gallery, i)}
                  >
                    <Image
                      src={img}
                      alt={`Event ${i + 1}`}
                      fill
                      className="object-cover group-hover:scale-110 transition-all duration-700 ease-in-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    {i === 3 && gallery.length > 4 && (
                      <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center backdrop-blur-[2px]">
                        <span
                          className="text-white text-3xl font-bold"
                          style={{ fontFamily: "Jost, sans-serif" }}
                        >
                          +{gallery.length - 4}
                        </span>
                        <span
                          className="text-white/80 text-sm font-medium uppercase tracking-wider"
                          style={{ fontFamily: "Jost, sans-serif" }}
                        >
                          More Photos
                        </span>
                      </div>
                    )}
                  </motion.div>
                ))}
              </div>
            </FadeInSection>
          </div>
        </div>
      </section>

      {/* Packages */}
      {/* <section className="py-24 md:py-32 bg-[#f5f1ec]">
        <div className="max-w-7xl mx-auto px-6">
          <FadeInSection>
            <div className="text-center mb-16">
              <p
                className="text-[#c9a961] tracking-widest mb-4"
                style={{ fontFamily: "Jost, sans-serif", fontSize: "0.875rem" }}
              >
                TAILORED FOR YOU
              </p>
              <h2
                className="text-4xl md:text-5xl lg:text-6xl text-[#2a2520] leading-tight"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontWeight: 400,
                }}
              >
                Event <span style={{ fontWeight: 600 }}>Packages</span>
              </h2>
            </div>
          </FadeInSection>

          <div className="grid md:grid-cols-3 gap-8">
            {packages.map((pkg, i) => (
              <FadeInSection key={i} delay={i * 0.1}>
                <motion.div
                  whileHover={{
                    y: -12,
                    boxShadow: "0 30px 60px rgba(0,0,0,0.15)",
                  }}
                  transition={{ duration: 0.4 }}
                  className={`bg-white shadow-lg overflow-hidden h-full flex flex-col ${pkg.popular ? "ring-4 ring-[#d4af37]" : ""}`}
                >
                  {pkg.popular && (
                    <div
                      className="bg-gradient-to-r from-[#5a6f3e] to-[#4a5f2e] text-white text-center py-2"
                      style={{
                        fontFamily: "Jost, sans-serif",
                        fontWeight: 600,
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}

                  <div className="p-8 flex-1 flex flex-col">
                    <h3
                      className="text-3xl text-[#2a2520] mb-2"
                      style={{
                        fontFamily: "Cormorant Garamond, serif",
                        fontWeight: 600,
                      }}
                    >
                      {pkg.name}
                    </h3>
                    <p
                      className="text-[#2a2520]/60 mb-6"
                      style={{ fontFamily: "Jost, sans-serif" }}
                    >
                      {pkg.guests}
                    </p>

                    <div className="mb-8">
                      <span
                        className="text-5xl text-[#5a6f3e]"
                        style={{
                          fontFamily: "Cormorant Garamond, serif",
                          fontWeight: 600,
                        }}
                      >
                        {pkg.price}
                      </span>
                      <span
                        className="text-[#2a2520]/60 ml-2"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        onwards
                      </span>
                    </div>

                    <ul className="space-y-4 mb-8 flex-1">
                      {pkg.features.map((feature, idx) => (
                        <li
                          key={idx}
                          className="flex items-start gap-3 text-[#2a2520]/80"
                          style={{ fontFamily: "Jost, sans-serif" }}
                        >
                          <Check className="w-5 h-5 text-[#5a6f3e] flex-shrink-0 mt-0.5" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>

                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className={`w-full py-4 text-center mt-auto cursor-pointer ${pkg.popular ? "bg-[#d4af37] text-[#2a2520]" : "bg-[#5a6f3e] text-white"} shadow-lg`}
                      style={{
                        fontFamily: "Jost, sans-serif",
                        fontWeight: 600,
                      }}
                    >
                      Select Package
                    </motion.button>
                  </div>
                </motion.div>
              </FadeInSection>
            ))}
          </div>

          <FadeInSection delay={0.3}>
            <div className="text-center mt-12">
              <p
                className="text-[#2a2520]/70 text-lg"
                style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
              >
                All packages are customizable. Contact us for a personalized
                quote.
              </p>
            </div>
          </FadeInSection>
        </div>
      </section> */}

      {/* Testimonials */}
      {eventDetail?.EventTestimonial &&
      eventDetail.EventTestimonial.length > 0 ? (
        <section className="py-24 md:py-32 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <FadeInSection>
              <div className="text-center mb-16">
                <h2
                  className="text-4xl md:text-5xl text-[#2a2520] leading-tight"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontWeight: 400,
                  }}
                >
                  Happy{" "}
                  <span style={{ fontWeight: 600, fontStyle: "italic" }}>
                    Customers
                  </span>
                </h2>
              </div>
            </FadeInSection>

            <div className="relative group">
              <div className="overflow-hidden px-4" ref={emblaRef}>
                <div className="flex -ml-6">
                  {eventDetail.EventTestimonial.map(
                    (testimonial: any, i: number) => (
                      <div
                        key={i}
                        className="flex-[0_0_100%] lg:flex-[0_0_50%] pl-6"
                      >
                        <motion.div
                          whileHover={{ y: -8 }}
                          className="bg-[#f5f1ec] p-8 shadow-lg h-full flex flex-col min-h-[350px]"
                        >
                          <div className="flex gap-1 mb-4">
                            {[...Array(5)].map((_, i) => (
                              <Star
                                key={i}
                                className="w-5 h-5 text-[#d4af37]"
                                fill="#d4af37"
                              />
                            ))}
                          </div>

                          <p
                            className="text-[#2a2520]/80 text-lg mb-6 leading-relaxed flex-grow"
                            style={{
                              fontFamily: "Jost, sans-serif",
                              fontWeight: 300,
                              fontStyle: "italic",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: cleanHeaderTags(testimonial?.Description),
                            }}
                          />

                          <div className="flex items-center gap-4 mt-auto">
                            <div className="w-16 h-16 rounded-full overflow-hidden relative border-2 border-[#d4af37]/20">
                              <Image
                                src={
                                  isValidImgSrc(testimonial?.TestimonialImage)
                                    ? testimonial?.TestimonialImage
                                    : "/imports/avatar.png"
                                }
                                alt={testimonial?.CustomerName}
                                fill
                                className="object-cover"
                              />
                            </div>
                            <div>
                              <p
                                className="text-[#2a2520]"
                                style={{
                                  fontFamily: "Jost, sans-serif",
                                  fontWeight: 600,
                                }}
                              >
                                {testimonial?.CustomerName}
                              </p>
                              <p
                                className="text-[#2a2520]/60 text-sm"
                                style={{ fontFamily: "Jost, sans-serif" }}
                              >
                                {testimonial?.EventName}
                              </p>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    ),
                  )}
                </div>
              </div>

              {totalTestimonials > 1 && (
                <>
                  <button
                    onClick={() => emblaApi?.scrollPrev()}
                    className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-xl p-3 rounded-full text-[#5a6f3e] hover:bg-[#5a6f3e] hover:text-white transition-all z-10 hidden md:block cursor-pointer"
                  >
                    <ChevronLeft className="w-6 h-6" />
                  </button>
                  <button
                    onClick={() => emblaApi?.scrollNext()}
                    className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-xl p-3 rounded-full text-[#5a6f3e] hover:bg-[#5a6f3e] hover:text-white transition-all z-10 hidden md:block cursor-pointer"
                  >
                    <ChevronRight className="w-6 h-6" />
                  </button>
                </>
              )}

              <div className="flex justify-center gap-2 mt-8">
                {eventDetail.EventTestimonial.map((_: any, i: number) => (
                  <button
                    key={i}
                    onClick={() => emblaApi?.scrollTo(i)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      selectedIndex === i
                        ? "bg-[#d4af37] w-8"
                        : "bg-[#5a6f3e]/20"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* Contact CTA */}
      {lookUpCMSData?.["Event Details - Section 1 : CTA"] && (
        <section className="py-24 md:py-32 bg-gradient-to-br from-[#5a6f3e] to-[#4a5f2e] text-white">
          <div className="max-w-4xl mx-auto px-6">
            <FadeInSection>
              <div
                className="text-center mb-12"
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    lookUpCMSData?.["Event Details - Section 1 : CTA"]
                      ?.Template,
                  ),
                }}
              />
              {/* <div className="text-center mb-12">
              <h2
                className="text-4xl md:text-5xl mb-6 leading-tight"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontWeight: 400,
                }}
              >
                Ready to{" "}
                <span style={{ fontWeight: 600, fontStyle: "italic" }}>
                  Start Planning?
                </span>
              </h2>
              <p
                className="text-xl text-white/90"
                style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
              >
                Our planning team is ready to bring your vision to life
              </p>
            </div> */}

              {(EventPhoneNo ||
                EventPhoneNo2 ||
                EventEmailID ||
                EventEmailID2 ||
                EventCallTiming) && (
                <div className="flex items-center justify-center flex-wrap gap-6 mb-12">
                  {(EventPhoneNo || EventPhoneNo2) && (
                    <div className="bg-white/10 backdrop-blur-md p-6 text-center hover:bg-white/20 transition-colors border border-white/20 flex-1 min-w-[250px] max-w-[350px]">
                      <Phone className="w-8 h-8 mx-auto mb-3 text-[#d4af37]" />
                      <p
                        className="text-sm text-white/70 mb-1"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        Call Us
                      </p>
                      {EventPhoneNo && (
                        <p
                          style={{
                            fontFamily: "Jost, sans-serif",
                            fontWeight: 600,
                          }}
                        >
                          <Link
                            href={`tel:${EventPhoneNo}`}
                            className="hover:text-[#5a6f3e] transition-colors"
                          >
                            {EventPhoneNo}
                          </Link>
                        </p>
                      )}
                      {EventPhoneNo2 && (
                        <p
                          style={{
                            fontFamily: "Jost, sans-serif",
                            fontWeight: 600,
                          }}
                        >
                          <Link
                            href={`tel:${EventPhoneNo2}`}
                            className="hover:text-[#5a6f3e] transition-colors"
                          >
                            {EventPhoneNo2}
                          </Link>
                        </p>
                      )}
                    </div>
                  )}

                  {(EventEmailID || EventEmailID2) && (
                    <div className="bg-white/10 backdrop-blur-md p-6 text-center hover:bg-white/20 transition-colors border border-white/20 flex-1 min-w-[250px] max-w-[350px]">
                      <Mail className="w-8 h-8 mx-auto mb-3 text-[#d4af37]" />
                      <p
                        className="text-sm text-white/70 mb-1"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        Email Us
                      </p>
                      {EventEmailID && (
                        <p
                          style={{
                            fontFamily: "Jost, sans-serif",
                            fontWeight: 600,
                          }}
                        >
                          <Link
                            href={`mailto:${EventEmailID}`}
                            className="hover:text-[#5a6f3e] transition-colors"
                          >
                            {EventEmailID}
                          </Link>
                        </p>
                      )}
                      {EventEmailID2 && (
                        <p
                          style={{
                            fontFamily: "Jost, sans-serif",
                            fontWeight: 600,
                          }}
                        >
                          <Link
                            href={`mailto:${EventEmailID2}`}
                            className="hover:text-[#5a6f3e] transition-colors"
                          >
                            {EventEmailID2}
                          </Link>
                        </p>
                      )}
                    </div>
                  )}

                  {EventCallTiming && (
                    <div className="bg-white/10 backdrop-blur-md p-6 text-center border border-white/20 flex-1 min-w-[250px] max-w-[350px]">
                      <Calendar className="w-8 h-8 mx-auto mb-3 text-[#d4af37]" />
                      <p
                        className="text-sm text-white/70 mb-1"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        Timings
                      </p>
                      <p
                        style={{
                          fontFamily: "Jost, sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        {EventCallTiming}
                      </p>
                    </div>
                  )}
                </div>
              )}

              <div className="text-center">
                <Link href={"/contact"}>
                  <motion.button
                    whileHover={{
                      scale: 1.05,
                      boxShadow: "0 20px 40px rgba(212, 175, 55, 0.4)",
                    }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-[#d4af37] text-[#2a2520] px-14 py-5 text-lg shadow-2xl inline-flex items-center gap-3 cursor-pointer"
                    style={{ fontFamily: "Jost, sans-serif", fontWeight: 600 }}
                  >
                    Schedule Site Visit
                    <ArrowRight className="w-5 h-5" />
                  </motion.button>
                </Link>
              </div>
            </FadeInSection>
          </div>
        </section>
      )}

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={currentGallery}
        index={currentIndex}
        styles={{ slide: { padding: 0 } }}
        render={{
          slide: ({ slide }) => (
            <div className="relative w-[90%] h-full flex items-center justify-center">
              <Image
                src={slide.src || ""}
                alt={"Gallery Image " + (currentIndex + 1)}
                fill
                sizes="(max-width: 768px) 100vw, 90vw"
                className="object-contain pointer-events-none"
              />
            </div>
          ),
        }}
      />
    </div>
  );
}
